import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import CompareByColumnsSkeleton from "../../Skeletons/CompareByColumnsSkeleton";
import { getAppConstantCategoryValue } from "../../../utils/constants";
import { toSentenceCase } from "../../../utils/constants";
import { useState } from "react";
import { Tooltip } from "primereact/tooltip";

const ColumnLayout = ({
  column,
  index,
  chooseComparison,
  comparisonOption,
  loading,
  category,
  comparisonOptions,
  handleCheckboxChange,
  setColumns,
  handleColumnChange,
  debounceFn,
  showSearchFilter = true,
  isDemoCategory = false,
  isCustomRecruitCategory = false,
  customRecruitCategories = [],
  handleUnCheckedCRCategories,
}) => {
  const unCheckedCRCategories =
    column?.unCheckedCRCategories && column?.unCheckedCRCategories?.length
      ? column?.unCheckedCRCategories
      : [];

  return (
    <>
      <div className="d-flex filter-columns align-items-baseline mb-2">
        {!column?.isColumnEditMode ? (
          <>
            <Tooltip target={`.column-name-${index}`} />
            {index === 0 ? (
              <div className="column-heading">
                {getAppConstantCategoryValue(isCustomRecruitCategory)}
              </div>
            ) : (
              <div
                className={`column-heading column-name-${index}`}
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  height: "29px",
                  // minWidth: "165px",
                  // maxWidth: "165px"
                }}
                data-pr-tooltip={
                  !column.value ? `Column ${index + 1}` : column.value
                }
                data-pr-position="top"
              >
                {!column.value ? `Column ${index + 1}` : column.value}
              </div>
            )}
            {index === 0 && chooseComparison !== "household" ? (
              ""
            ) : (
              <span
                className="pi pi-pencil pencil-icon ms-2"
                onClick={() =>
                  setColumns((prevColumns) =>
                    prevColumns.map((col, i) =>
                      i === index
                        ? {
                            ...col,
                            isColumnEditMode: !col.isColumnEditMode,
                            columnEditVal: col.value,
                          }
                        : col,
                    ),
                  )
                }
              ></span>
            )}
          </>
        ) : (
          <>
            {chooseComparison === "household" ||
            (index !== 0 && chooseComparison !== "household") ? (
              <div className="d-flex align-items-center w-100">
                <InputText
                  name={`key_${index + 1}`}
                  value={
                    column.isColumnEditMode
                      ? column.columnEditVal
                      : column.value || ""
                  } // Ensure value is empty initially
                  onChange={
                    (e) =>
                      (chooseComparison === "household" ||
                        (index !== 0 && chooseComparison !== "household")) &&
                      handleColumnChange(index, e.target.value) // Only allow changes for non-category columns
                  }
                  className="mb-1 column-input py-0"
                  placeholder={`Column ${index + 1}`} // Placeholder for each column
                  // style={{ backgroundColor: "#f5f5f5" }}
                  disabled={index === 0 && chooseComparison !== "household"} // Disable the first column (Category)
                />
                <div className="filter-input-buttons d-flex align-items-center">
                  <Button
                    className="filter-input-button1 me-1"
                    onClick={() =>
                      setColumns((prevColumns) =>
                        prevColumns.map((col, i) =>
                          i === index
                            ? {
                                ...col,
                                isColumnEditMode: !col.isColumnEditMode,
                                value: !col?.columnEditVal
                                  ? col?.value
                                  : col?.columnEditVal,
                              }
                            : col,
                        ),
                      )
                    }
                  >
                    <span className="pi pi-check"></span>
                  </Button>
                  <Button
                    className="filter-input-button2"
                    aria-label="Cancel"
                    onClick={() =>
                      setColumns((prevColumns) =>
                        prevColumns.map((col, i) =>
                          i === index
                            ? {
                                ...col,
                                isColumnEditMode: !col.isColumnEditMode,
                                columnEditVal: "",
                              }
                            : col,
                        ),
                      )
                    }
                  >
                    <span className="pi pi-times"></span>
                  </Button>
                </div>
              </div>
            ) : (
              ""
            )}
          </>
        )}
      </div>
      {index === 0 && chooseComparison !== "household" ? (
        <>
          {(
            isCustomRecruitCategory
              ? isCustomRecruitCategory
              : comparisonOption.length
          ) ? (
            <div
              className={`d-flex flex-column ${isCustomRecruitCategory && customRecruitCategories?.length ? "h-100" : "h-75"}`}
            >
              {isCustomRecruitCategory && customRecruitCategories?.length ? (
                <div
                  className="scroll-panel-custom panel-height"
                  style={{ maxHeight: "240px" }}
                >
                  {customRecruitCategories?.map(
                    (customRecruitCategory, idx) => (
                      <div
                        className="d-flex align-items-center pt-2 pb-2"
                        key={idx}
                      >
                        <Checkbox
                          inputId={`custom-category-${idx}`}
                          checked={
                            !unCheckedCRCategories?.some(
                              (crValue) =>
                                crValue?.id === customRecruitCategory?.id,
                            )
                          }
                          onChange={(e) => handleUnCheckedCRCategories(e.value)}
                          value={customRecruitCategory}
                        />
                        <label
                          htmlFor={`custom-category-${idx}`}
                          className="ms-2"
                          // style={{
                          //   overflow: "hidden",
                          //   textOverflow: "ellipsis",
                          //   whiteSpace: "nowrap",
                          // }}
                          title={customRecruitCategory?.name}
                        >
                          {customRecruitCategory?.name}
                        </label>
                      </div>
                    ),
                  )}
                </div>
              ) : (
                <div className="d-flex align-items-baseline pt-2 pb-2">
                  <Checkbox inputId={`category-${index}`} checked={true} />
                  <label
                    htmlFor={`category-${index}`}
                    className="ms-2"
                    // style={{
                    //   overflow: "hidden",
                    //   textOverflow: "ellipsis",
                    //   whiteSpace: "nowrap",
                    // }}
                    title={getAppConstantCategoryValue(isCustomRecruitCategory)}
                  >
                    {isCustomRecruitCategory
                      ? "Custom Recruit"
                      : category?.replace(/^Custom Recruit -\s*/, "") +
                        " Average"}
                  </label>
                </div>
              )}

              {/* {isCustomRecruitCategory ? (
                <div className="mt-auto">
                  <Divider />
                  <div className="d-flex pt-2 pb-2">
                    <Checkbox
                      inputId={`category-recruit-${index}`}
                      checked={checkCustomRecruitSyndicated}
                      onChange={() =>
                        setCheckCustomRecruitSyndicated(
                          !checkCustomRecruitSyndicated,
                        )
                      }
                    />
                    <label
                      htmlFor={`category-recruit-${index}`}
                      className="ms-2"
                      // style={{
                      //   overflow: "hidden",
                      //   textOverflow: "ellipsis",
                      //   whiteSpace: "nowrap",
                      // }}
                    >
                      {getAppConstantCategoryValue(isCustomRecruitCategory)}
                    </label>
                  </div>
                </div>
              ) : (
                ""
              )} */}
            </div>
          ) : (
            ""
          )}
        </>
      ) : loading && chooseComparison !== "" ? (
        <CompareByColumnsSkeleton />
      ) : (
        <>
          {chooseComparison !== null &&
          comparisonOption.length &&
          showSearchFilter ? (
            <div className="search-filter d-flex align-items-center">
              <span className="search-icon pi pi-search text-secondary pe-2"></span>
              <InputText
                name={`search_key_${index + 1}`}
                value={column.filterVal || ""}
                onChange={(e) => {
                  setColumns((prevColumns) =>
                    prevColumns.map((col, i) =>
                      i === index ? { ...col, filterVal: e.target.value } : col,
                    ),
                  );
                  debounceFn(e.target.value, index);
                }}
                className="mb-1 search-input column-input"
                placeholder={toSentenceCase(
                  `Search ${comparisonOptions.find((option) => option.value === chooseComparison)?.searchLabel}`,
                )} // Placeholder for each search
                // style={{
                //   backgroundColor: "#f5f5f5"
                // }}
              />
            </div>
          ) : (
            ""
          )}
          {chooseComparison !== null && column?.colComparisonOptions?.length ? (
            <div className="scroll-panel-custom panel-height">
              {chooseComparison !== null &&
                column?.colComparisonOptions?.map((option) => (
                  <div
                    key={option.value}
                    className="d-flex align-items-center pt-2 pb-2"
                  >
                    <Checkbox
                      inputId={`${option.value}-${index}`}
                      checked={column.selectedComparisons.includes(
                        option.value,
                      )}
                      onChange={() => handleCheckboxChange(index, option)}
                    />
                    <label
                      htmlFor={`${option.value}-${index}`}
                      className="ms-2"
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        // minWidth: "165px",
                        // maxWidth: "165px"
                      }}
                      title={option.label}
                    >
                      {/* {option.label.length > 19
                        ? option.label.slice(0, 14) + "..."
                        : option.label} */}
                      {isDemoCategory ? option.label : option.label}
                    </label>
                  </div>
                ))}
            </div>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default ColumnLayout;
